<template>
    <v-app>
        

        <v-main>
            <v-container>

                <div class="userinfo">
                        
                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: "AjustesView",
    components: {  },
    data() {
        return {
            user: [],
            drawer: false,
        };
    },

    methods: {
        obtenerDatos() {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user) {
                this.user = user;
            }
        },
    },
    mounted() {
        this.obtenerDatos();
    },
};
</script>

<style>
.text-decoration-none {
    text-decoration: none;
}


.userinfo {
    text-align: center;

}
</style>